module.exports = __webpack_public_path__ + "static/img/pencils5-transparent-UK.16f068b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pencils5-transparent-UK.png
// module id = 177
// module chunks = 2